import { defineMessages } from 'react-intl-next';

export const i18n = defineMessages({
	verified: {
		id: 'search-page.filters.names.verified',
		defaultMessage: 'Verified',
		description: 'Label for filtering for Verified content',
	},
});
